var exports = {
  "D": "xdde3148b--b50c16--layout-section",
};

module.exports = exports;
